
<iframe [style.height]="innerHeight" id="DebtCollectionIframe" style="width: 100%;" [src]="certurl | safe" title="Debt Collection"></iframe>
